
export const THIRD_TYPE = 'ETC_PHONE'

export const QA_LIST = [
  { question: '哪些车辆可以办理ETC ？', answer: '支持小型汽车（9座以内）、出租车、网约车办理。' },
  { question: '是否全国通行？全国高速95折？', answer: '全国高速已实现联网，ETC设备均可畅行并享受≥5%的普惠政策，如路段还有其他优惠可叠加同享。' },
  { question: '怎么办理ETC？', answer: 'ETC助手提供免费办理与付费办理ETC方式，选择付费ETC支付后或达成免费申办条件即可享受超快发货，发货后根据包装盒内二维码指引在线上传车主本人身份证、车辆行驶证、车辆正面照片（含车牌），支持非车主代办，也可绑非车主本人微信。' },
  { question: '办理怎么收费？', answer: '选择银行补贴项目是免费的，后续使用无任何年费、手续费、服务费。选择付费办理需要支付180元，并且加送价值100元路费券或2年延保服务。' },
  { question: '什么是新一代免插卡式设备？', answer: '对比市面常见的一卡一签套餐款，ETC助手新一代免插卡式设备，采用卡签一体化设计，外观更小巧精致，搭配电池芯片升级，性能更强。' },
  { question: '办理后多久能发货？', answer: '当天17点前提交办理申请的最快当天寄出，预计2-3个工作日可收到ETC设备。' },
  { question: '如何安装与激活设备？', answer: '收到货后扫描包装盒内说明书二维码，根据指引和视频教程，上传资料、签约后，通过手机蓝牙连接设备，只需1分钟即可自助完成安装。' },
  { question: '通行后如何扣费？', answer: '出站后将自动使用微信免密支付，扣除已绑定的银行卡余额，扣费会有延迟，一般是1天内扣费，部分路段会有数天延迟。' },
  { question: '是否需要绑定银行卡？', answer: '无需绑定银行卡，支持微信支付多种扣费方式。' },
  { question: '高速通行费的发票如何开具？', answer: '关注“微信-ETC助手”公众号，打开“服务-ETC发票”，即可开具高速通行发票。' },
]

export const PG_PLATE_COLOR_LIST = {
  0: {
    color: '蓝色',
    text: '蓝牌',
  },
  1: {
    color: '黄色',
    text: '黄牌',
  },
  2: {
    color: '黑色',
    text: '黑牌',
  },
  3: {
    color: '白色',
    text: '白牌',
  },
  4: {
    color: '渐变绿色',
    text: '绿牌',
  },
  5: {
    color: '黄绿渐变色',
    text: '黄绿',
  },
  6: {
    color: '蓝白渐变色',
    text: '蓝白',
  },
  7: {
    color: '临时车牌',
    text: '临牌',
  },
  9: {
    color: '未确定',
    text: '未知',
  },
  11: {
    color: '绿色车牌',
    text: '绿牌',
  },
  12: {
    color: '红色',
    text: '红牌',
  },
}

export const PG_CARD_STATUS = {
  1: '正常',
  2: '有卡挂起',
  3: '无卡挂起',
  4: '有卡注销',
  5: '无卡注销',
  6: '卡挂失',
}

export const CHANNEL_INFO = {
  'aion': {
    channelName: '埃安',
    companyId: 'xconnect',
    orderType: 'enterprise',
    referValue: 4,
    mainColor: '#2DCCD3',
    linkColor: '#2CCAD1',
    bgColor: '#E5F5F6',
    successIcon: 'https://wecos.etczs.net/h5/enterprice/success-icon-aion.png',
    buyEntryImg: 'https://wecos.etczs.net/h5/enterprice/center-buy-entry-aion.png',
    btnBg: '#1B1B1B',
    headerBg: '#EAEFF4',
  },
  'hyptec': {
    channelName: '昊铂',
    companyId: 'haobo',
    orderType: 'enterprise',
    referValue: 7,
    mainColor: '#F7BE7F',
    linkColor: '#2F97FF',
    bgColor: '#FFF8F2',
    successIcon: 'https://wecos.etczs.net/h5/enterprice/success-icon-hyptec.png',
    buyEntryImg: 'https://wecos.etczs.net/h5/enterprice/center-buy-entry-hyptec-1104.png',
    btnBg: '#F7BE7F',
    headerBg: '#4A5E7F',
  },
  'gac': {
    channelName: '传祺',
    companyId: '',
    orderType: 'app',
    referValue: 5,
    mainColor: '#BDE900',
    linkColor: '#BDE900',
    bgColor: '#f3fbd3',
    successIcon: 'https://wecos.etczs.net/h5/enterprice/success-icon.png',
    buyEntryImg: 'https://wecos.etczs.net/h5/enterprice/center-buy-entry-gac.png',
    btnBg: '#1B1B1B',
    headerBg: 'C2E820',
  },
}

export const ENTERPRISE_REFER_VALUE = Object.values(CHANNEL_INFO).filter(item => item.orderType === 'enterprise').map(item => item.referValue)
